import { useEffect, useId, useState } from 'react';
import { Button } from '../admin-ui';
import { t } from '../../localization/adminText';

export default function DesignerActions({ dirty, saving, disabled, onSave, onDiscard }) {
  const id = 'cod-form-save-' + useId().replace(/:/g, '');
  const [nativeFailed, setNativeFailed] = useState(false);
  const native = Boolean(window.shopify?.saveBar) && !nativeFailed;
  const discard = () => {
    if (!saving && window.confirm(t('Discard unsaved form changes?'))) onDiscard();
  };
  useEffect(() => {
    if (!native) return;
    try {
      Promise.resolve(dirty || saving ? window.shopify.saveBar.show(id) : window.shopify.saveBar.hide(id)).catch(() => setNativeFailed(true));
    } catch { setNativeFailed(true); }
  }, [dirty, saving, id, native]);
  useEffect(() => () => { window.shopify?.saveBar?.hide(id)?.catch?.(() => {}); }, [id]);
  useEffect(() => {
    if (!dirty && !saving) return;
    const unload = event => { event.preventDefault(); event.returnValue = ''; };
    const navigate = event => {
      const link = event.target.closest?.('a[href]');
      if (!link || link.target === '_blank' || event.ctrlKey || event.metaKey || event.button !== 0) return;
      if (saving || !window.confirm(t('Leave this page and discard unsaved form changes?'))) {
        event.preventDefault(); event.stopPropagation();
      } else onDiscard();
    };
    window.addEventListener('beforeunload', unload);
    document.addEventListener('click', navigate, true);
    return () => { window.removeEventListener('beforeunload', unload); document.removeEventListener('click', navigate, true); };
  }, [dirty, saving, onDiscard]);
  return <>
    {native && <ui-save-bar id={id}>
      <button variant="primary" disabled={disabled || saving} onClick={onSave}>{t(saving ? 'Saving…' : 'Save settings')}</button>
      <button disabled={saving} onClick={discard}>{t('Discard changes')}</button>
    </ui-save-bar>}
    {(!native || (!dirty && !saving)) && <>
      {dirty && <Button onClick={discard} disabled={saving}>{t('Discard changes')}</Button>}
      <Button variant="primary" onClick={onSave} loading={saving} disabled={disabled || !dirty}>{t('Save settings')}</Button>
    </>}
  </>;
}
